import { useState, useMemo } from 'react';
import ShopLayout from '../components/ShopLayout';
import DealCard from '../components/DealCard';
import { WEARABLES, WEARABLE_TYPES } from '../data/wearables';

export default function WearablesPage() {
  const [search, setSearch] = useState('');
  const [type, setType] = useState('All');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return WEARABLES.filter(w => {
      const matchType = type === 'All' || w.type === type;
      const matchSearch = !q || w.name.toLowerCase().includes(q) || w.brand.toLowerCase().includes(q);
      return matchType && matchSearch;
    });
  }, [search, type]);

  return (
    <ShopLayout
      title="Wearables & Accessories"
      subtitle="Smartwatches, earbuds, fitness bands and gaming — all on one plan."
      search={search}
      onSearch={setSearch}
      filters={WEARABLE_TYPES}
      activeFilter={type}
      onFilter={setType}
    >
      {filtered.length === 0
        ? <p className="shop-empty">No deals match your search.</p>
        : filtered.map(w => <DealCard key={w.id} deal={w} type="wearables" />)
      }
    </ShopLayout>
  );
}
